<template>
    <article class="error404">
        <h2>404</h2>
        <div class="content">
            <p>Strona, której szukasz nie istnieje lub została przeniesiona. Spróbuj ponownie później lub skorzystaj z mapy strony</p>
        </div>
    </article>
</template>

<script>
    export default {
        name: "error",
        props: [],
        data() {
            return {
                'sex': true,
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/error.vue